<template>
  <v-layout wrap v-if="jadwalKerja">
    <v-flex xs12>
      <m-card title="Detail Hari Libur">
        <v-layout wrap>
          <v-flex xs12 sm7 md8>
            <v-list>
              <v-subheader class="title green--text">Identitas</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="No. Reg" :value="jadwalKerja.settingJadwal_id"/>
              <m-list-tile-info label="Nama" :value="jadwalKerja.nama"/>
              <m-list-tile-info label="Surel" :value="jadwalKerja.email"/>
              <v-subheader class="title green--text">Alamat</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="Alamat" :value="jadwalKerja.alamat"/>
            </v-list>
          </v-flex>
        </v-layout>
      </m-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      jadwalKerja: null
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("jadwalKerja/detail", this.$route.params.settingJadwal_id)
        .then(res => {
          this.page = res.data;
          this.jadwalKerja = res.data;
        })
        .catch(e => e);
    },
    close() {
      this.$router.push({
        name: "jadwalKerja"
      });
    }
  }
};
</script>
